import { Container, Vector2 } from '@cgs/wge';
import { FreeFallReelsConfig } from '../../../reels_engine/free_fall_reels_engine/free_fall_reels_config';
import { IReelsConfig } from '../../../reels_engine/i_reels_config';
import { SlotParams } from '../../../reels_engine/slot_params';
import { T_IGameParams, RESOURCES_COMPONENT_TOKEN } from '../../../type_definitions';
import { IReelsConfigProvider } from '../interfaces/i_reels_config_provider';
import { ResourcesComponent } from '../resources_component';

export class FreeFallReelsConfigComponent implements IReelsConfigProvider {
  public reelsConfig: IReelsConfig;

  constructor(container: Container) {
    console.log('load ' + this.constructor.name);
    const resourcesComponent = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    const slotParams = container.resolve<SlotParams>(T_IGameParams);

    const maxIconLength: number =
      slotParams.longIcons.length > 0
        ? slotParams.longIcons
            .map((e) => e.length)
            .reduce(
              (prevValue: number, currValue: number) =>
                currValue > prevValue ? currValue : prevValue,
              0
            )
        : 0;

    const iconFrameStart = resourcesComponent.findStartReelNode(0);
    const iconFrameEnd = resourcesComponent.slot.findById('slot_end')!;
    const symbolSize = new Vector2(
      (iconFrameEnd.position.x - iconFrameStart.position.x) / (slotParams.reelsCount - 1),
      (iconFrameEnd.position.y - iconFrameStart.position.y) / (slotParams.linesCount - 1)
    );
    const slotSize = new Vector2(
      symbolSize.x * slotParams.reelsCount,
      symbolSize.y * slotParams.linesCount
    );

    const reelsOffset = Array.from(
      { length: slotParams.reelsCount },
      (_, i) => new Vector2(0.0, resourcesComponent.findStartReelNode(i).position.y)
    );

    this.reelsConfig = new FreeFallReelsConfig(
      slotSize,
      symbolSize,
      slotParams.reelsCount,
      slotParams.linesCount,
      reelsOffset,
      new Vector2(0.0, symbolSize.y * -maxIconLength)
    );
  }
}
